import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { navActions } from 'entities/NavMenu'
import styles from './LegalPage.module.scss'

const operator =
    'Рубанов Владислав Андреевич, самозанятый (НПД), ИНН 502732101043'

const DocumentShell = ({ children, title }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(navActions.setVisible(false))
    }, [dispatch])

    return (
        <main className={styles.page}>
            <article className={styles.document}>
                <a className={styles.homeLink} href="/">
                    MineCards
                </a>
                <h1>{title}</h1>
                <p className={styles.revision}>
                    Редакция от 13 сентября 2026 г.
                </p>
                {children}
            </article>
        </main>
    )
}

export const TermsPage = () => (
    <DocumentShell title="Пользовательское соглашение">
        <section>
            <h2>1. Общие положения</h2>
            <p>
                Настоящее соглашение определяет правила использования
                веб-приложения MineCards по адресу minecards.app (далее —
                «Сервис»). Владелец Сервиса — {operator} (далее — «Владелец»).
            </p>
            <p>
                Сервис предназначен для лиц, достигших 14 лет. Начиная или
                продолжая использовать Сервис, пользователь подтверждает свой
                возраст и принимает настоящее соглашение.
            </p>
        </section>

        <section>
            <h2>2. Сервис и аккаунт</h2>
            <p>
                MineCards позволяет просматривать карточки, сохранять мечты и
                достижения, вести публичный профиль, добавлять друзей и
                предлагать новые карточки. Сервис предоставляется бесплатно и
                может использоваться с локальной сессией либо с привязкой
                электронной почты.
            </p>
            <p>
                Пользователь отвечает за доступ к своему устройству и почте, а
                также за достоверность размещаемых им сведений.
            </p>
        </section>

        <section>
            <h2>3. Публичный профиль</h2>
            <p>
                Все профили в MineCards публичны. Имя, никнейм, аватар, фон,
                описание, Telegram, списки карточек и количество созданных
                карточек могут быть доступны другим пользователям по ссылке на
                профиль. Размещая эти сведения, пользователь поручает Сервису
                показывать их в своём публичном профиле.
            </p>
            <p>
                Не следует размещать конфиденциальные сведения или персональные
                данные других людей без законного основания.
            </p>
        </section>

        <section>
            <h2>4. Пользовательский контент</h2>
            <p>
                Пользователь сохраняет права на созданный им контент и
                предоставляет Владельцу право хранить, воспроизводить, публично
                показывать и модерировать его в объёме, необходимом для работы
                Сервиса.
            </p>
            <p>
                Предложенная пользователем и одобренная карточка может войти в
                общий каталог MineCards. После удаления аккаунта такая карточка
                может остаться в каталоге без связи с удалённым профилем.
                Владелец вправе отклонить или удалить контент, нарушающий закон,
                права третьих лиц или правила Сервиса.
            </p>
        </section>

        <section>
            <h2>5. Ограничения</h2>
            <p>
                Запрещено нарушать работу Сервиса, получать доступ к чужим
                аккаунтам, размещать незаконный или вредоносный контент,
                нарушать права третьих лиц и использовать Сервис для спама.
            </p>
        </section>

        <section>
            <h2>6. Работа Сервиса</h2>
            <p>
                Сервис предоставляется «как есть». Его функции могут изменяться,
                а работа — временно прерываться. Ответственность Владельца
                ограничивается в пределах, допускаемых законодательством
                Российской Федерации.
            </p>
        </section>

        <section>
            <h2>7. Удаление аккаунта и связь</h2>
            <p>
                Для удаления аккаунта или решения вопроса об использовании
                Сервиса напишите на{' '}
                <a href="mailto:team@minecards.app">team@minecards.app</a>.
                Владелец может запросить сведения, необходимые для подтверждения
                связи пользователя с профилем.
            </p>
            <p>
                К соглашению применяется законодательство Российской Федерации.
                Актуальная редакция публикуется на этой странице.
            </p>
        </section>
    </DocumentShell>
)

export const PrivacyPage = () => (
    <DocumentShell title="Политика конфиденциальности">
        <section>
            <h2>1. Общие положения</h2>
            <p>
                Политика описывает обработку персональных данных в
                веб-приложении MineCards по адресу minecards.app. Оператор
                персональных данных — {operator}. Контакт:{' '}
                <a href="mailto:team@minecards.app">team@minecards.app</a>.
            </p>
            <p>Сервис предназначен для лиц, достигших 14 лет.</p>
        </section>

        <section>
            <h2>2. Какие данные обрабатываются</h2>
            <ul>
                <li>
                    данные аккаунта и сессии: электронная почта, внутренние
                    идентификаторы и данные авторизации;
                </li>
                <li>
                    данные публичного профиля: имя, никнейм, аватар, фон,
                    описание и Telegram;
                </li>
                <li>
                    действия в Сервисе: списки карточек, друзья, предложенные
                    карточки и загруженные изображения;
                </li>
                <li>
                    необходимые технические данные: IP-адрес, сведения о
                    браузере и устройстве, время и результаты запросов.
                </li>
            </ul>
        </section>

        <section>
            <h2>3. Цели и основания обработки</h2>
            <p>
                Данные обрабатываются для работы Сервиса, создания и
                восстановления сессии, ведения публичных профилей, сохранения
                действий пользователя, модерации предложений, поддержки и
                безопасности. Основания обработки — исполнение настоящего
                соглашения и обязанности Оператора, установленные законом.
            </p>
        </section>

        <section>
            <h2>4. Публичность данных</h2>
            <p>
                Все профили публичны. Данные профиля, списки карточек и
                количество созданных карточек доступны другим пользователям по
                ссылке. Пользователь самостоятельно определяет содержание
                профиля и не должен размещать чужие персональные данные без
                законного основания.
            </p>
            <p>
                Одобренные карточки могут публиковаться в общем каталоге. После
                удаления аккаунта они могут сохраняться в обезличенном виде без
                связи с профилем автора.
            </p>
        </section>

        <section>
            <h2>5. Хранение и передача</h2>
            <p>
                Данные хранятся, пока существует аккаунт или этого требует
                закон. Для размещения Сервиса и отправки кодов входа
                используется Timeweb Cloud. При поиске GIF запрос обрабатывается
                сервисом GIPHY по действию пользователя. Данные также могут быть
                переданы государственным органам в случаях, предусмотренных
                законом.
            </p>
            <p>
                MineCards не использует системы веб-аналитики и рекламные
                cookies. Необходимые cookies и локальное хранилище используются
                для сессии, настроек и работы интерфейса.
            </p>
        </section>

        <section>
            <h2>6. Права пользователя</h2>
            <p>
                Пользователь может запросить сведения о своих данных, их
                уточнение, прекращение обработки или удаление аккаунта, написав
                на <a href="mailto:team@minecards.app">team@minecards.app</a>.
                Для защиты аккаунта Оператор может попросить подтвердить связь с
                профилем. Запрос исполняется в сроки, установленные законом;
                данные, которые необходимо хранить по закону, удаляются после
                окончания такого срока.
            </p>
        </section>

        <section>
            <h2>7. Изменения</h2>
            <p>Актуальная редакция Политики публикуется на этой странице.</p>
        </section>
    </DocumentShell>
)
